// Account Menu Compinent Code
//
class AccountMenu extends HTMLButtonElement {
  constructor() {
    super();
  
    this.icon = this.querySelector(".account-icon")
    this.menu = this.closest(".account-menu-container").querySelector(".account-dropdown-menu")
    this.container = this.closest(".account-menu-container")
    this.links = this.menu.querySelectorAll("a")
  }

  connectedCallback() {

    this.addEventListener("click", () => {
      this.menu.classList.remove("hidden")
    })

    this.icon.addEventListener("click", () => {
      this.menu.classList.remove("hidden")
    })

    this.container.addEventListener("mouseenter", () => {
      this.menu.classList.remove("hidden")
    })

    this.container.addEventListener("mouseleave", () => {
      this.menu.classList.add("hidden")
    })

    this.container.addEventListener("focusout", () => {
        this.dataset.acsbFocused = false
    })

    this.links.forEach((link) => {
      this.container.addEventListener("focusin", () => {
        this.container.dataset.acsbFocused = false
        link.dataset.acsbFocused = true
      })
    })

    this.container.addEventListener("focusin", () => {
      this.menu.ariaHidden = false
      this.links.forEach((link) => {
        // console.log("YES CHANGE")
        // link.dataset.acsbForceUnnavigable = 
        // link.dataset.acsbNowNavigable = true
        // link.dataset.acsbClickable = true
        // link.dataset.acsbCustomButtonProcessed = true
        link.tabIndex = 0
      })
    })
  }
}


customElements.define("account-menu", AccountMenu, { extends: "button" });
